export const JOURNEYS_DIMENSIONS_WHITELIST = [
  'attributed',
  'origin',
  'last_attributed_touch_data_tilde_creative_id',
  'last_attributed_touch_data_tilde_tune_publisher_id',
  'last_attributed_touch_data_dollar_marketing_title',
  'last_attributed_touch_data_tilde_content_id',
  'last_attributed_touch_data_tilde_campaign',
  'last_attributed_touch_data_tilde_channel',
  'last_attributed_touch_data_tilde_feature',
  'last_attributed_touch_data_tilde_stage',
  'last_attributed_touch_data_tilde_tags',
  'last_attributed_touch_data_tilde_journey_name',
  'last_attributed_touch_data_tilde_journey_id',
  'last_attributed_touch_data_tilde_journey_customer_version',
  'last_attributed_touch_data_tilde_view_name',
  'last_attributed_touch_data_tilde_view_id',
  'last_attributed_touch_data_plus_web_format',
  'last_attributed_touch_data_tilde_agency_id',
  'last_attributed_touch_data_tilde_agency',
  'last_attributed_touch_data_tilde_keyword_id',
  'user_data_platform',
  'user_data_environment',
  'user_data_geo_country_code',
  'user_data_os',
  'user_data_os_version',
  'user_data_has_app',
  'user_data_standard_events_completed',
  'user_data_custom_events_completed',
  'user_data_has_clicked_ad',
  'user_data_has_clicked_email',
  'dismissal_source',
  'user_data_app_store',
  'user_data_cpp_level',
  'deep_linked',
] as const;
